import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {MoreInfo, SideStampRow, SideStampWrapper} from "./styles";
import check from "../../../../assets/images/reservation/check.svg";
import InstantBookingInfoDialog from "../InstantBookingInfoDialog/InstantBookingInfoDialog";
import { Stamp } from "../Stamp";

const InstantBookingSideStamp = () => {
    const {t} = useTranslation();
    const [ibDialogOpen, setIbDialogOpen] = useState(false);

    return <SideStampWrapper>
        <SideStampRow>
            <Stamp />
        </SideStampRow>
        <SideStampRow>
            <img src={check} alt="check"/>
            <span>{t('IMMEDIATE_BOOKING_CONFIRMATION')}</span>
        </SideStampRow>
        <SideStampRow>
            <img src={check} alt="check"/>
            <span>{t('ONLINE_CREDIT_CARD_PAYMENT')}</span>
        </SideStampRow>
        <SideStampRow>
            <img src={check} alt="check"/>
            <span>{t('VERIFIED_BERTH_AVAILABILITY')}</span>
        </SideStampRow>
        <MoreInfo onClick={() => setIbDialogOpen(true)}>{t('MORE_INFO')}</MoreInfo>
        <InstantBookingInfoDialog variant="general" open={ibDialogOpen} onClose={() => setIbDialogOpen(false)} />
    </SideStampWrapper>
}

export default InstantBookingSideStamp;
